import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  margin-bottom: 20px;

  a {
    width: 100%;
    margin: 0;
  }

  a + a,
  button + a {
    margin-top: 10px;
  }

  ${media.moreThan('sm')`
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;

    a {
      width: auto;
    }

    a + a, button + a {
      margin-top: auto;
      margin-left: 20px;
    }
  `};
`;
